module.exports = __webpack_public_path__ + "img/l_Xcode.81907338.svg";